module.exports = __webpack_public_path__ + "static/media/Step2Withdrawal.61a2bf0a.svg";